<template>
    <div class="container">
        <div class="header">
            <span>考生操作手册</span>
            <el-button class="exit" size="mini" @click="exit()"> 退出 </el-button>
        </div>
        <div class="main">
            <div class="main-clone">
                <div class="pptBox" id="pptBox" v-loading="tableing" :style="{overflowY:tableing? 'hidden':'auto'}"  element-loading-text="正在加载中..." element-loading-background="#F9FCFF">
                    <canvas v-for="page in pages" :id="'the-canvas'+page" :key="page"></canvas>
                </div>
                <div class="goExamBox">
                    <el-checkbox class="agreeCheckBox" v-model="checked" size="medium">我已阅读并知晓考生手册内容</el-checkbox>
                    <el-button class="upSub" @click="lastQuestion()" :disabled="timeIs5>0" :style="{background:(timeIs5>0? '#8ba1c1':'')}"> 下一步 <span v-show="timeIs5>0">( {{timeIs5}} )</span></el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import PDFJS from 'pdfjs-dist';
import workerSrc from 'pdfjs-dist/build/pdf.worker.entry'
import util from '../../lib/util';
PDFJS.workerSrc = workerSrc;
    export default {
        name:"testManual",
        data() {
            return {
                tableing:false,
                checked:false,
                pages:[],
                timeIs5:5,
                timeSet:null,
                // pathUrl:"https://aitestgo-bj-art.oss-cn-beijing.aliyuncs.com/acg/examresource/164005556000016400551695573510717.pdf"
                pathUrl:"https://aitestgo-bj-art.oss-cn-beijing.aliyuncs.com/acg/examresource/16400555600001640055169557418862.pdf"
            }
        },
        components:{},
        watch: {},
        computed:{},
        created(){},
        beforeDestroy() {
            this.timeSet && window.clearInterval(this.timeSet)
        },
        mounted(){
            this.tableing = true
            this.$nextTick(()=>{
                let that = this
                let url = that.pathUrl
                that._loadFile(url);  
                that.timeSet = window.setInterval(() => {
                    that.timeIs5--;
                    if(that.timeIs5<=3&&that.tableing)that.tableing = false
                    if(that.timeIs5<=0){
                        window.clearInterval(that.timeSet)
                    }
                }, 1000);
            })
        },
        methods:{
            initIframe(){  //高度自适应函数
                var ifm= document.getElementById("iframetest");
                try{
                    let ha = ifm.contentWindow.document.body.scrollHeight;
                    let hb = ifm.contentWindow.document.documentElement.scrollHeight;
                    let hc = Math.min(ha, hb);
                    ifm.height = hc;
                }catch (ex){}
            },
            _renderPage (num) {
                this.pdfDoc.getPage(num).then((page) => {
                    let canvas = document.getElementById('the-canvas' + num)
                    var vp = page.getViewport({scale: 1});
                    let ctx = canvas.getContext('2d')
                    let dpr = window.devicePixelRatio || 1
                    let bsr = ctx.webkitBackingStorePixelRatio ||
                        ctx.mozBackingStorePixelRatio ||
                        ctx.msBackingStorePixelRatio ||
                        ctx.oBackingStorePixelRatio ||
                        ctx.backingStorePixelRatio || 1
                    let ratio = dpr / bsr
                    let viewport = page.getViewport({scale: window.innerWidth / vp.width});
                    canvas.width = viewport.width * ratio
                    canvas.height = viewport.height * ratio
                    // canvas.style.width = viewport.width + 'px'
                    // canvas.style.height = '614px'
                    canvas.style.height = 'auto'
                    ctx.setTransform(ratio, 0, 0, ratio, 0, 0)
                    let renderContext = {
                        canvasContext: ctx,
                        viewport: viewport
                    }
                    page.render(renderContext)
                    if (this.pages > num) {
                        this._renderPage(num + 1)
                    }
                })
            },
            _loadFile (url) {
                PDFJS.getDocument(url).promise.then((pdf) => {
                    this.pdfDoc = pdf
                    this.pages = this.pdfDoc.numPages
                    this.$nextTick(() => {
                        this._renderPage(1);
                    });
                });
            },
            exit(){
                this.$confirm('请问是否退出当前考试？','确认信息',{
                    distinguishCancelAndClose:true,
                    confirmButtonText:'是',
                    cancelButtonText:'否',
                })
                .then(()=>{
                    if(sessionStorage.getItem('orgId')){//测评
                        this.$router.push({
                            path: `/${sessionStorage.getItem('orgId')}/examList`,
                        })
                    }else{
                        this.$router.push({
                            path: '/myExamList'
                        })
                    }
                })
                .catch(action=>{})
            },
            lastQuestion(){
                this.$nextTick(()=>{
                    if(!this.checked){
                        this.$message.warning('请您阅读考生操作手册并勾选');
                        return
                    }
                    let href_ = window.location.href.split('#/')[1]
                    let lv = href_.indexOf('?')!=-1? href_.split('?')[0]:''
                    let menuListArr = this.$route.query.menuList.split(',')
                    let menuListLoc = menuListArr.indexOf(String(util.menuListGet().indexOf(lv)))
                    this.$router.push({
                        path: `/${util.menuListGet()[menuListArr[menuListLoc+1]]}`,
                        query: {
                            bId:this.$route.query.bId,
                            paperName:this.$route.query.paperName,
                            userSignId:this.$route.query.userSignId,
                            ticketNum:this.$route.query.ticketNum,
                            idName:this.$route.query.idName,
                            idCardNo:this.$route.query.idCardNo,
                            youXunExamId:this.$route.query.youXunExamId,
                            youXunExamNum:this.$route.query.youXunExamNum,
                            examStartDate:this.$route.query.examStartDate,
                            examEndDate:this.$route.query.examEndDate,
                            examStatus:this.$route.query.examStatus,
                            examStartDateVal:this.$route.query.examStartDateVal,
                            examEndDateVal:this.$route.query.examEndDateVal,
                            examMin:this.$route.query.examMin,
                            personNum:this.$route.query.personNum,
                            reviewType:this.$route.query.reviewType,
                            menuList:this.$route.query.menuList,
                        }
                    })
                })
            },
        }
    }
</script>
<style scoped lang="less">
    .container{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .header{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 19px;
        font-weight: bold;
        color: #000;
        border-bottom: 1px solid #EDEEED;
        .exit{
            background-color: #31C4FE;
            border: none;
            font-size: 15px;
            width: 74px;
            height: 32px;
            color: #fff;
            position: absolute;
            top: 15px;
            right: 3%;
            img{
                height: 10px;
            }
        }
    }
    .main{
        position: absolute;
        top: 75px;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        .main-clone{
            height:100%;
            width: 100%;
            overflow: hidden;
            position: relative;
            .pptBox{
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 20%;
                width: 100%;
                margin: 0 auto;
                box-sizing: border-box;
                overflow-x: hidden;
                canvas{
                    height: 100%;
                    width: 100%;
                }
            }
            .goExamBox{
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                height: 20%;
                width: 100%;
                // position: relative;
                .agreeCheckBox{
                    position: absolute;
                    left: 0;
                    top: 17%;
                    right: 0;
                    margin: 0 auto;
                }
                .upSub{
                    position: absolute;
                    left: 0;
                    top: 40%;
                    right: 0;
                    bottom: 0;
                    margin: 0 auto;
                    height: 45px;
                    width: 35%;
                    background: rgb(0, 75, 180);
                    color: #FFF;
                    border-radius: 3px;
                    font-size: 18px;
                }
            }
            .blockBoxs{
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                height: 20%;
                width: 100%;
                .closeBtus{
                    position: absolute;
                    left: 0;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    margin: auto;
                    height: 45px;
                    width: 35%;
                    background: rgb(0, 75, 180);
                    color: #FFF;
                    border-radius: 3px;
                    font-size: 18px;
                }
            }
        }
    }
</style>
<style>
    .agreeCheckBox .el-checkbox__inner{
        height: 17px !important;
        width: 17px !important;  
    }
    .agreeCheckBox .el-checkbox__label{
        font-size: 18px !important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/myExamList/testManual.vue